import React, { useState } from "react";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const Back = ({ className }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const baseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '5px 8px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    color: isHovered ? '#21AA73' : '#495057'
  };
  
  const hoverStyle = {
    backgroundColor: isHovered ? 'rgba(33, 170, 115, 0.08)' : 'transparent',
  };
  
  return (
    <div 
      onClick={() => window.history.back()} 
      style={{...baseStyle, ...hoverStyle}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={className}
    >
      <KeyboardBackspaceIcon 
        fontSize="small" 
        style={{
          marginRight: '4px',
          transform: isHovered ? 'translateX(-2px)' : 'translateX(0)',
          transition: 'transform 0.2s ease'
        }}
      />
      <span style={{fontSize: 14, fontWeight: isHovered ? 500 : 400}}>Back</span>
    </div>
  )
}

export default Back